import { initializeApp, getApps } from "firebase/app";

/**
 * Single Firebase app instance for client RTDB (player + admin read-only listeners).
 */
export function getFirebaseApp() {
  const url = process.env.REACT_APP_FIREBASE_DATABASE_URL;
  if (!url) return null;
  if (getApps().length > 0) return getApps()[0];
  return initializeApp({
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: url,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  });
}
